import React, { useState } from 'react';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="volumes" className="defer-paint w-full scroll-mt-6 bg-ink py-14 sm:py-20" aria-labelledby="volumes-heading" data-id="element-221" data-mp="7pem43t6hm04">
      <div className="mx-auto max-w-4xl px-6" data-id="element-222" data-mp="3g4g717twwzqw">
        <SectionHeading eyebrow="The complete system" title={<span id="volumes-heading" data-id="element-224" data-mp="3c4fi2t96t65l">
              The complete system that organizes your handball coaching
            </span>} data-id="element-223" data-mp="3g5hmdohyo8ef" />

        <p className="mx-auto mt-3 max-w-2xl text-center leading-relaxed text-muted" data-id="element-225" data-mp="3pwlvi7kygz1c">
          Open any volume and immediately see what to coach, how to organize it,
          and how to progress it.
        </p>

        <ol className="mt-10 space-y-3" data-id="element-226" data-mp="2xcndncaxlcin">
          {volumes.map((volume, index) => {
          const isOpen = openIndex === index;
          return <li key={volume.code} className="relative overflow-hidden rounded-3xl border bg-navy transition-colors duration-150 ease-out" style={{
            borderColor: isOpen ? volume.color : undefined
          }} data-id="element-227" data-mp="29g0ho9a51im6" data-mpi={index}>
                <span className="absolute inset-y-0 left-0 w-1.5" style={{
              backgroundColor: volume.color
            }} aria-hidden="true" data-id="element-228" data-mp="2j6d11y67v5qq" />
                <h3 data-id="element-229" data-mp="1qgmj1e1grjpc">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`volume-panel-${index}`} className="flex w-full items-center gap-4 rounded-3xl py-4 pl-6 pr-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent sm:gap-5 sm:pl-8 sm:pr-6" data-id="element-230" data-mp="1qh61qwyxuc4f">
                    <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full font-display text-2xl font-extrabold text-white" style={{
                  backgroundColor: volume.color
                }} aria-hidden="true" data-id="element-231" data-mp="24e2rev3blnjq">
                      {volume.code}
                    </span>
                    <span className="min-w-0 flex-1" data-id="element-232" data-mp="1brzv60b6jxel">
                      <span className="block font-display text-sm font-semibold uppercase tracking-[0.18em] text-muted" data-id="element-233" data-mp="1br7w2fidjhjk">
                        Volume {volume.code} · {volume.count}
                      </span>
                      <span className="mt-0.5 block font-display text-xl font-bold uppercase leading-tight text-fg sm:text-2xl" data-id="element-234" data-mp="1kt7jbpjzfhuy">
                        {volume.name}
                      </span>
                    </span>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-panel transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-235" data-mp="16smw8h71azvn">
                      <ChevronDownIcon className="h-4 w-4 text-muted" data-id="element-236" data-mp="ecc4sc75rjng" />
                    </span>
                  </button>
                </h3>

                <div id={`volume-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-237" data-mp="9chiklybvi8q">
                  <div className="overflow-hidden" data-id="element-238" data-mp="2psvx53u2d9do">
                    <div className="border-t border-line py-5 pl-6 pr-5 sm:pl-8 sm:pr-6" data-id="element-239" data-mp="2c06bx1md08hm">
                      <p className="text-[0.98rem] leading-relaxed text-fg/90" data-id="element-240" data-mp="2gz0t5z4ohozm">{volume.intro}</p>

                      <ul className="mt-4 flex flex-wrap gap-2" data-id="element-241" data-mp="34ollh8mq1ylk">
                        {volume.highlights.map(item => <li key={item} className="rounded-full border px-3 py-1 text-[0.85rem] font-medium text-fg" style={{
                      borderColor: `${volume.color}80`,
                      backgroundColor: `${volume.color}1f`
                    }} data-id="element-242" data-mp="38q6ugiw4xsqh">
                            {item}
                          </li>)}
                      </ul>

                      <p className="mt-5 flex items-start gap-2.5 rounded-2xl bg-panel px-4 py-3 text-[0.92rem] font-medium leading-snug text-fg" data-id="element-243" data-mp="1j9nz38vu2sr0">
                        <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent/15" aria-hidden="true" data-id="element-244" data-mp="23jqiufzuxz8p">
                          <CheckIcon className="h-3 w-3 text-accent" strokeWidth={3} data-id="element-245" data-mp="1yrp9p2xzkomw" />
                        </span>
                        <span data-id="element-246" data-mp="1urx0qp4okgh0">
                          <span className="font-display font-bold uppercase tracking-wide text-accent" data-id="element-247" data-mp="1psu33pr15cj2">Result: </span>
                          {volume.result}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}